export const TABS = ['공공기관', '상장사'];
